import React, { useEffect } from 'react';
import { Card, Typography, Spin } from 'antd';
import { useUser } from '@clerk/clerk-react';

const { Title, Text } = Typography;

// Pricing Page Component
const Pricing = () => {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    // Load Stripe price table script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="pricing-page" style={{
      background: 'linear-gradient(135deg, #212169 0%, #2a2a7a 30%, #f8f9fa 30%, #f8f9fa 100%)',
      minHeight: '100vh',
      padding: '80px 16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }}>
      <Card style={{
        width: "100%",
        maxWidth: 900,
        padding: 40,
        borderRadius: 16,
        background: 'rgba(255, 255, 255, 0.95)',
        border: '1px solid rgba(33, 33, 105, 0.1)',
        boxShadow: '0 8px 32px rgba(33, 33, 105, 0.15)',
        backdropFilter: 'blur(10px)'
      }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <Title
            level={2}
            style={{
              marginBottom: 8,
              fontWeight: 600,
              color: '#212169',
              fontSize: '2rem'
            }}
          >
            Choose Your Plan
          </Title>
          <Text
            style={{
              color: 'rgba(33, 33, 105, 0.7)',
              fontSize: 16,
              lineHeight: 1.6
            }}
          >
            Select a subscription plan to access Hooptie's premium features
          </Text>
        </div>

        {!isLoaded ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin size="large" />
            <div style={{ marginTop: 16, color: 'rgba(33, 33, 105, 0.7)' }}>
              Loading pricing options...
            </div>
          </div>
        ) : (
          <div style={{
            borderRadius: 12,
            overflow: 'hidden',
            border: '1px solid rgba(33, 33, 105, 0.1)'
          }}>
            <stripe-pricing-table
              pricing-table-id="prctbl_1RphjaR653i23TabsvNj8WWA"
              publishable-key={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}
              client-reference-id={user?.id}
              customer-email={user?.primaryEmailAddress?.emailAddress}>
            </stripe-pricing-table>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Pricing;